var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZonePicking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 4.5H5C4.33696 4.5 3.70107 4.76339 3.23223 5.23223C2.76339 5.70107 2.5 6.33696 2.5 7V25C2.5 25.663 2.76339 26.2989 3.23223 26.7678C3.70107 27.2366 4.33696 27.5 5 27.5H27C27.663 27.5 28.2989 27.2366 28.7678 26.7678C29.2366 26.2989 29.5 25.663 29.5 25V7C29.5 6.33696 29.2366 5.70107 28.7678 5.23223C28.2989 4.76339 27.663 4.5 27 4.5ZM26.5 7.5V9.5H5.5V7.5H26.5ZM5.5 24.5V12.5H26.5V24.5H5.5ZM22.5 15.5C22.5 17.2239 21.8152 18.8772 20.5962 20.0962C19.3772 21.3152 17.7239 22 16 22C14.2761 22 12.6228 21.3152 11.4038 20.0962C10.1848 18.8772 9.5 17.2239 9.5 15.5C9.5 15.1022 9.65804 14.7206 9.93934 14.4393C10.2206 14.158 10.6022 14 11 14C11.3978 14 11.7794 14.158 12.0607 14.4393C12.342 14.7206 12.5 15.1022 12.5 15.5C12.5 16.4283 12.8687 17.3185 13.5251 17.9749C14.1815 18.6313 15.0717 19 16 19C16.9283 19 17.8185 18.6313 18.4749 17.9749C19.1313 17.3185 19.5 16.4283 19.5 15.5C19.5 15.1022 19.658 14.7206 19.9393 14.4393C20.2206 14.158 20.6022 14 21 14C21.3978 14 21.7794 14.158 22.0607 14.4393C22.342 14.7206 22.5 15.1022 22.5 15.5Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZonePicking);
export default __webpack_public_path__ + "static/media/ZonePicking.3e49bd29.svg";
export { ForwardRef as ReactComponent };